export const ACCEPTED_SUPPORT_FILES = '.xls, .xlsx, .pdf, .doc, .docx, .odt, .pptx'
